<template>
  <page-edicion>
    <page-header :title="tarifa.nombre" subtitle="Tarifa" back-to="/tarifas" />
    <formulario :tarifa="tarifa" @submit="actualizar" />
  </page-edicion>
</template>

<script>
import Formulario from "./Formulario.vue";
import api from "@/services/tarifas.js";

export default {
  components: { Formulario },
  data() {
    return {
      tarifa: {},
    };
  },
  mounted() {
    this.cargar(this.$route.params.id);
  },
  methods: {
    cargar(id) {
      api.cargar(id).then((response) => {
        this.tarifa = response;
      });
    },
    actualizar() {
      var tarifa = {
        tarifa: this.tarifa,
      };
      api.actualizar(tarifa).then(() => {
        this.$router.push({ path: "/tarifas" });
      });
    },
  },
};
</script>
